export const FIXED = 'fixed';
export const FILL = 'fill';
export const TRASH = 'trash';
export const JPG = 'jpg';
export const PNG = 'png';
export const SVG = 'svg';
export const UPLOADED_IMAGE = 'Uploaded image';
export const IMAGE = 'image';
export const IMAGES = 'images';
export const IS_MAIN = 'isMain';
export const FORMAT = 'format';
export const ARROW = 'arrow';
export const SMALL = 'small';
export const CHOOSE_FILE = 'Choose file';
export const VERTICAL = 'vertical';
export const COLORED = 'colored';

//position
export const CENTER = 'center';
export const RIGHT = 'right';
export const TOP = 'top';
export const TOP_LEFT = 'top-left';
export const TOP_RIGHT = 'top-right';
export const TOP_CENTER = 'top-center';
export const BOTTOM_LEFT = 'bottom-left';
export const BOTTOM_RIGHT = 'bottom-right';
export const BOTTOM_CENTER = 'bottom-center';

//alt
export const IMAGE_PREVIEW_ALT = 'Image preview';
export const IMAGE_AVATAR_ALT = 'Image avatar';
export const IMAGE_TABLE_ALT = 'Image table';

export const isFile = (value: unknown): value is File => typeof window !== 'undefined' && value instanceof File;
